import * as React from "react";
const SvgFiRrRingDiamond = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M14.932 6.5 16.6 4.39c.594-.791.514-1.915-.216-2.644L14.772.264A1 1 0 0 0 14.095 0h-4.19c-.25 0-.492.094-.677.264L7.586 1.775c-.7.7-.779 1.824-.17 2.634L9.069 6.5C5.543 7.72 3.001 11.065 3.001 15c0 4.962 4.038 9 9 9s9-4.038 9-9c0-3.935-2.544-7.28-6.069-8.5M8.97 3.218 10.295 2h3.418l1.303 1.169-2.268 2.869A9 9 0 0 0 12.001 6c-.254 0-.504.017-.753.038zM12 22c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7"
    />
  </svg>
);
export default SvgFiRrRingDiamond;
